import { useGetPendingWhitelistedAddressesQuery } from '../generated/graphql'

interface PendingAddress {
  id: string
  address: string
  chain: string
  label?: string | null
  companyId: string
  companyName: string
  requester?: {
    id: string
    username: string
    email: string
  } | null
  createdAt: string
}

export function usePendingAddresses(groupId: string | undefined) {
  const [{ data }] = useGetPendingWhitelistedAddressesQuery({
    variables: { groupId: groupId || '' },
    pause: !groupId,
  })

  const pendingAddresses: PendingAddress[] =
    data?.getPendingWhitelistedAddresses?.map((addr) => ({
      id: addr.id,
      address: addr.address,
      chain: addr.chain,
      label: addr.label,
      companyId: addr.companyId,
      companyName: addr.companyName,
      requester: addr.requester,
      createdAt: addr.createdAt,
    })) || []

  return {
    pendingAddresses,
    count: pendingAddresses.length,
  }
}
